import styled from 'styled-components';
export const TextButton = styled.button `
    border: 0;
    display: block;
    background: none;
    appearance: none;
    font-family: inherit;
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1;
    padding: 0;
    color: #ffffff;

    &:active {
        transform: translateY(0.0625rem);
    }
`;
